module.exports = __webpack_public_path__ + "static/media/discord.2fde8683.svg";